// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xpWl","toggle":"styles_toggle__nkj63","preview":"styles_preview__1SAGr"};